'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  apiHostMobile: 'localhost',
  apiPortMobile: 3018,
  app: {
    title: 'Nenudím se',
    description: 'S námi se děti nenudí! Vytváříme u dětí pozitivní vztah ke sportu pomocí zábavného motivačního programu, který je zaměřen na všestranný rozvoj pohybových dovedností.',
    head: {
      titleTemplate: '%s - Nenudím se',
      lang: 'cs',
      meta: [{ name: 'description', content: 'S námi se děti nenudí! Vytváříme u dětí pozitivní vztah ke sportu pomocí zábavného motivačního programu, který je zaměřen na všestranný rozvoj pohybových dovedností.' }, { charset: 'utf-8' }, { 'theme-color': '#ffffff' }, { property: 'og:site_name', content: 'Nenudím se' }, { property: 'og:image', content: 'https://www.nenudimse.cz/logo.png' }, { property: 'og:locale', content: 'cs_CZ' }, { property: 'og:title', content: 'Nenudím se' }, { property: 'og:description', content: 'S námi se děti nenudí! Vytváříme u dětí pozitivní vztah ke sportu pomocí zábavného motivačního programu, který je zaměřen na všestranný rozvoj pohybových dovedností.' },
      /* {property: 'og:card', content: 'summary'},
      {property: 'og:site', content: '@erikras'},
      {property: 'og:creator', content: '@erikras'}, */
      { property: 'og:image:width', content: '160' }, { property: 'og:image:height', content: '40' }],
      link: [{ 'rel': 'apple-touch-icon', 'href': '/apple-touch-icon.png', 'sizes': '180x180' }, { 'rel': 'icon', 'type': 'image/png', 'href': '/favicon-32x32.png', 'sizes': '32x32' }, { 'rel': 'icon', 'type': 'image/png', 'href': '/favicon-16x16.png', 'sizes': '16x16' }, { 'rel': 'manifest', 'href': '/manifest.json' }, { 'rel': 'mask-icon', 'href': '/safari-pinned-tab.svg', 'color': '#ff0000' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 565
// module chunks = 0